import React, { PropTypes } from 'react'
import t from 'tcomb-form'
import { cloneDeep } from 'lodash/lang'
import { EmailRefinement } from '../utils/tcomb-utils'
import { Link } from 'react-router'
import settings from '../settings'
import FacebookLoginButton from './FacebookLoginButton'
import ReCAPTCHA from 'react-google-recaptcha'


export const flowTransformer = {
  format: (value) => {
    return JSON.stringify(value)
  },
  parse: (str) => {
    return (str)
  }
}

const capitalize = (val) => (val && val.length > 0 && (val[0]).toUpperCase() + val.slice(1) || val)

const must_be_true = t.refinement(t.Boolean, (n) => (n === true)  )

const formSchema = t.struct({
  first_name: t.String,
  last_name: t.String,
  email: EmailRefinement,
  password1: t.String,
  password2: t.String,
  //newsletter: t.Boolean,
  flow: t.String,
  recaptcha: t.String
})


const formOptions = {
  auto: 'none',
  error: 'Acount creation failed',
  hasError: false,
  fields: {
    first_name: {
      error: 'First Name cannot be blank',
      attrs: {
        placeholder: 'First Name'
      }
    },
    last_name: {
      error: 'Last Name cannot be blank',
      attrs: {
        placeholder: 'Last Name'
      }
    },
    email: {
      error: 'Please provide a valid email address',
      type: 'email',
      attrs: {
        placeholder: 'Email'
      }
    },

    password1: {
      error: 'Please enter a password',
      type: 'password',
      attrs: {
        placeholder: 'Password'
      }
    },

    password2: {
      type: 'hidden'
    },
    /*
    newsletter: {
      label: 'Yes! Send me newsletters.'
    },
    */
    flow: {
      type: 'hidden',
      transformer: flowTransformer
    },
    recaptcha: {
      error: "You must check I am not a robot",
      type: 'text',
      attrs: {
        style: {display: 'none'}
      }
    },
  }
}

class SignupForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      formValue: {},
      formOptions: formOptions
    }
  }

  componentWillMount() {}

  componentDidMount() {
    this.setFormState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.setFormState(nextProps)
  }

  setFormState = (props) => {
    const { signup, location: { query } } = props
    let flow = (props.flow) ? props.flow : ['/user/info']

    let newFormOptions = cloneDeep(this.state.formOptions)

    if (signup.error) {
      newFormOptions.hasError = true
      newFormOptions.error = (
        <div className="alert alert-danger">
          <span><i className="fa fa-warning"> {signup.message || signup.error || 'Account creation failed.' }</i></span>
        </div>
      )

      if (signup.nonFieldErrors) {
        newFormOptions.error = (
          <div className="alert alert-danger">
            <p><i className="fa fa-warning"> {signup.message || signup.error || 'Account creation failed.' }</i></p>
            <ul style={ {listStyle: 'none', paddin: 0, margin: 0} }>
              {signup.nonFieldErrors.map(e => { return <li>{e}</li> })}
            </ul>
          </div>
        )
      }

      if (signup.fieldErrors) {
        for (let fieldName in formOptions.fields) {
          if (signup.fieldErrors[fieldName]) {
            newFormOptions.fields[fieldName].hasError = true
            newFormOptions.fields[fieldName].error = signup.fieldErrors[fieldName].map(e => { return <span>{e}</span>})
          } else {
            newFormOptions.fields[fieldName].hasError = false
            newFormOptions.fields[fieldName].error = formOptions.fields[fieldName].error
          }
        }
      }
    }

    if (query.next) {
      flow = [ query.next ]
    }

    this.setState({ formValue: { ...this.state.formValue, flow, }, formOptions: newFormOptions})
  }

  onFormChange = (formValue) => {
    this.setState({ formValue: {
      ...formValue,
      first_name: capitalize(formValue.first_name),
      last_name: capitalize(formValue.last_name),
      password2: formValue.password1
    }})
  }

  signup = (event) => {
    event.preventDefault()
    event.stopPropagation()
    const { location: { query } } = this.props

    let value = this.refs.signupForm.getValue()
    if (value) {
      this.props.doSignupUser(value)
    } else {
      let newFormOptions = Object.assign(this.state.formOptions)
      newFormOptions.hasError = true
      newFormOptions.error = <span><i className="fa fa-warning"> Account creation failed.</i></span>
      this.setState({ formOptions: newFormOptions })
    }
  }

  onReCaptchaChange = (value) => {
    const formValue = Object.assign(this.state.formValue)
    this.setState({ formValue: {
      ...formValue,
      recaptcha: value
    }})
  }

  render() {
    let { browser } = this.props
    return (
      <form className="signupForm" onSubmit={this.signup}>
        <h1 className="signupFormHeading">Sign up</h1>
        <p className="signupFormTagline">
          Join the WorldWideWomen community to receive special members-only benefits &ndash;
          previews of new resources, inspiring stories and videos, invitations to local events, and more
        </p>


        <t.form.Form ref="signupForm"
                    value={this.state.formValue}
                    onChange={this.onFormChange}
                    type={formSchema}
                    options={this.state.formOptions} />
        <ReCAPTCHA
          className="recaptcha"
          ref="recaptcha"
          sitekey={settings.recaptcha.key}
          onChange={this.onReCaptchaChange}
        />

        <button className="button button-primary"
                style={{display: 'block', width: '100%', marginTop: '2.0rem'}}
                type="submit">Sign up</button>
        
      </form>
    )

  }

}

export default SignupForm



// WEBPACK FOOTER //
// ./src/components/SignupForm.jsx